<template>
	<div
		:class="[
			'img-tile',
			{'is-checked': tile.isChecked},
			{'is-disabled': tile.isDisabled}
		]"
	>
		<div class="img-tile__inner">
			<div class="img-tile__checkbox"></div>
			<div
				class="img-tile__img"
				:style="imgStyleObject"
			>
				<img
					class="visually-hidden"
					:src="tile.src"
					:alt="tile.txt"
				>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			tile: {
				required: true
			}
		},
		computed: {
			imgStyleObject() {
				return this.tile.src ? {
					backgroundImage: `url('${this.tile.src}')`
				} : {};
			}
		}
	};
</script>

<style lang="scss">
	@import "~sass/_config.scss";
	@import '~sass/_variables.scss';
	@import "~sass/mixins/_media-query.scss";

	.img-tile {
		$b: &;

		position: relative;
		width: 100%;
		padding-bottom: 82%;

		&__inner {
			background-color: $col-neutral--0;
			border: 1px solid $col-neutral--3;
			transition: background-color $ttime;
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
		}

		&__checkbox {
			display: block;
			position: absolute;
			top: 7px;
			left: 7px;
			width: 18px;
			height: 18px;
			border-radius: 50%;
			border: 1px solid $col-neutral--3;
			background-color: $col-neutral--0;
			overflow: hidden;
			transition: background-color, border-color;
			transition-duration: $ttime;

			&::before {
				content: '';
				display: block;
				position: absolute;
				width: 7px;
				height: 3px;
				border-left: 3px solid $col-neutral--0;
				border-bottom: 3px solid $col-neutral--0;
				top: 45%;
				left: 110%;
				transform: translateX(-50%) translateY(-50%) rotate(-45deg);
				transition: left $ttime;
			}
		}

		&__img {
			position: absolute;
			top: 20px;
			right: 20px;
			bottom: 20px;
			left: 20px;
			background-size: contain;
			background-repeat: no-repeat;
			background-position: 50% 50%;
		}

		&::before {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			box-shadow: 0 3px 6px rgba($col-neutral--9, 0.16);
			opacity: 0;
			transition: opacity $ttime;
		}

		&::after {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: $col-neutral--0;
			opacity: 0;
			transition: opacity $ttime;
		}

		&.is-checked {
			#{$b}__inner {
				background-color: $col-neutral--1;
			}

			#{$b}__checkbox {
				background-color: $col-positive--1;
				border-color: $col-positive--1;

				&::before {
					left: 50%;
				}
			}

			&::before {
				opacity: 1;
			}
		}

		&.is-disabled {
			pointer-events: none;

			&::after {
				opacity: 0.6;
			}
		}

		&:hover {
			cursor: pointer;

			#{$b}__inner {
				background-color: $col-neutral--1;
			}
		}
	}
</style>